export default function _functionName(f) {
  // String(x => x) evaluates to "x => x", so the pattern may not match.
  var match = String(f).match(/^function (\w*)/);
  return match == null ? '' : match[1];
}


//////////////////
// WEBPACK FOOTER
// ./~/ramda/es/internal/_functionName.js
// module id = 1763
// module chunks = 1